import React, { useEffect, useState } from 'react';
import { Button, Form, Space } from 'antd';
import { useParams } from 'react-router-dom';
import TinyInput from '../../inputs/TinyInput';
import {
  AddInfoContentService,
  GetInfoContentService,
} from '../../services/infoContentServices';
import Notifications from './components/Notifications';
import useTranslation from '../../../hooks/translation/useTranslation';

function InfoContent() {
  const { trans } = useTranslation();
  const { type } = useParams();

  if (type === 'notifications') {
    return <Notifications />;
  }

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await GetInfoContentService({
        type,
      });
      if (response.status === 'success') {
        form.setFieldValue('content', response.data.content);
      } else {
        form.setFieldValue('content', '');
      }
    } catch {
      //  Empty block
    }
    setIsLoading(false);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await AddInfoContentService({
        content: form.getFieldValue('content'),
        type,
      });
      if (response.status === 'success') {
        await fetchData();
      }
    } catch (e) {
      setErrors(e.response.data?.errors);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [type]);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Form form={form} onFinish={handleSubmit}>
        <TinyInput
          form={form}
          setValueName="content"
          label={trans(type?.replaceAll('-', '_'))}
          errorMessage={errors?.content}
          name="content"
        />
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {trans('submit')}
          </Button>
        </Form.Item>
      </Form>
    </Space>
  );
}

export default InfoContent;
